// ================================
// pages/legal/TermsOfService.js
// ================================
import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const TermsOfService = () => (
  <div className="legal-page">
    <div className="legal-container">
      <div className="legal-header">
        <Link to="/" className="legal-back">← Back</Link>
        <h1>Terms of Service</h1>
        <p className="legal-date">Last updated: March 7, 2025 — SynexStudio</p>
      </div>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing or using RizzingBot ("the Service"), operated by SynexStudio ("we", "us", "our"), you agree to be bound by these Terms of Service. If you do not agree, please do not use the Service.</p>
        <p>RizzingBot is an AI-powered assistant designed to help users improve their dating conversations. The Service is intended for adults aged 18 and over.</p>
      </section>

      <section>
        <h2>2. Description of Service</h2>
        <p>RizzingBot provides AI-generated message suggestions, sentiment analysis, conversation coaching, and related features to assist users in their personal communications. The Service operates on a credit-based system with optional paid subscription plans.</p>
        <p>The Service is provided for entertainment and informational purposes only. We make no guarantees about the outcomes of using our suggestions.</p>
      </section>

      <section>
        <h2>3. Account Registration</h2>
        <h3>3.1 Eligibility</h3>
        <p>You must be at least 18 years old to create an account. By registering, you confirm that you meet this requirement.</p>
        <h3>3.2 Account Security</h3>
        <p>You are responsible for maintaining the confidentiality of your account credentials. Notify us immediately at <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a> if you suspect unauthorized access.</p>
        <h3>3.3 Accurate Information</h3>
        <p>You agree to provide accurate and complete information during registration and to keep your account information up to date.</p>
      </section>

      <section>
        <h2>4. Credits and Subscriptions</h2>
        <h3>4.1 Free Credits</h3>
        <p>New users receive complimentary credits upon registration to explore the Service.</p>
        <h3>4.2 Subscription Plans</h3>
        <p>RizzingBot offers paid subscription plans (Starter, Premium, Pro) that provide monthly credit allocations. Plan details and pricing are displayed on the subscription page.</p>
        <h3>4.3 Credit Usage</h3>
        <p>Credits are consumed when using AI features. Unused credits do not carry over between billing periods. Credits have no monetary value and cannot be exchanged for cash.</p>
        <h3>4.4 Billing</h3>
        <p>Subscriptions are billed monthly. Payments are processed securely through Stripe. By subscribing, you authorize us to charge your payment method on a recurring basis until you cancel.</p>
      </section>

      <section>
        <h2>5. Acceptable Use</h2>
        <p>You agree NOT to use the Service to:</p>
        <ul>
          <li>Harass, stalk, or harm any individual</li>
          <li>Generate content that is illegal, defamatory, or abusive</li>
          <li>Attempt to reverse-engineer or exploit the Service</li>
          <li>Use the Service for commercial purposes without our written consent</li>
          <li>Violate any applicable laws or regulations</li>
        </ul>
        <p>We reserve the right to suspend or terminate accounts that violate these terms without prior notice.</p>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <p>All content, features, and functionality of RizzingBot are owned by SynexStudio and protected by applicable intellectual property laws. You retain ownership of the content you input into the Service.</p>
      </section>

      <section>
        <h2>7. Disclaimers</h2>
        <p>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. SYNEXSTUDIO DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR ERROR-FREE. AI-generated suggestions are not professional advice.</p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>TO THE MAXIMUM EXTENT PERMITTED BY LAW, SYNEXSTUDIO SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE SERVICE. Our total liability shall not exceed the amount you paid us in the three months preceding the claim.</p>
      </section>

      <section>
        <h2>9. Termination</h2>
        <p>You may cancel your account at any time through your account settings. Credits associated with your account will be forfeited upon termination.</p>
      </section>

      <section>
        <h2>10. Governing Law</h2>
        <p>These Terms are governed by the laws of France. Any disputes shall be subject to the exclusive jurisdiction of the courts of Rouen, France.</p>
      </section>

      <section>
        <h2>11. Contact</h2>
        <p><strong>Email:</strong> <a href="mailto:synexstudio76@gmail.com">synexstudio76@gmail.com</a></p>
        <p><strong>Company:</strong> SynexStudio — Rouen, France</p>
      </section>

      <div className="legal-footer">
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/refund">Refund Policy</Link>
        <Link to="/legal">Legal Notice</Link>
      </div>
    </div>
  </div>
);

export default TermsOfService;